import { z } from "zod";

import { fetchWithError, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

export const legendSchema = z.object({
  colormap_type: z.string(),
  legend: z.array(z.object({ value: z.number(), color: z.string() })),
  limits: z.tuple([z.number(), z.number()]),
  name: z.string(),
  labels: z.record(z.string(), z.record(z.string(), z.string()).optional()),
});

export type Legend = z.infer<typeof legendSchema>;

export function useWmsGetLegend(layer: string, style: string, baseUrl = "/wms/") {
  const url = combineUrlAndParams(baseUrl, {
    service: "wms",
    request: "getlegend",
    layer,
    style,
  });

  return useParsedQuery<Legend>(
    ["lizard-api-v4", "wms", url],
    () => fetchWithError(url),
    (json: unknown) => legendSchema.parse(json)
  );
}
